import useWorkspaceID from './use-workspace-id';

/**
 * Return a full URL that includes the workspace ID that you are currently in
 * @param href The relative route from the top level workspace (e.g. page/123)
 */
export default function useWorkspaceUrl(href: string): string {
  const workspaceID = useWorkspaceID();
  if (!workspaceID) return '/'; // See use-lazy-workspace-url for an explanation

  const workspaceAwareHref = `/${workspaceID}/${href}`;

  return workspaceAwareHref;
}
